import { useMemo, useState } from 'react';
import { useStateInRef } from 'seagull';
import { useOverlayContext, useIoContext } from "../contexts";
import { handleRequest, wait } from "../infra/utils";
import { selectors } from "../store/state-selectors";
import { useStoreActions, useStoreStatic } from "../store/store-context";
const exchangeTokenLoader = 'exchangePlaidPublicToken';
const linkTokenLoader = 'linkToken';
export let PlaidMode = /*#__PURE__*/function (PlaidMode) {
  PlaidMode["Vendor"] = "vendor";
  PlaidMode["Customer"] = "customer";
  return PlaidMode;
}({});
export function usePlaidState(props) {
  const getProps = useStateInRef(props);
  const {
    usePlaidLink
  } = useIoContext();
  const {
    api,
    logBI
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  const [linkToken, setLinkToken] = useState(null);
  const {
    getState
  } = useStoreStatic();
  const options = useMemo(() => {
    return {
      token: linkToken,
      onExit() {
        logBI(10005, {
          success: false
        });
        const {
          onExit
        } = getProps();
        onExit && onExit();
      },
      onSuccess: async publicToken => {
        const businessId = selectors.user.businessId(getState());
        const role = selectors.user.role(getState());
        const userId = selectors.user.id(getState());
        const {
          mode
        } = getProps();
        logBI(10005, {
          success: true
        });
        if (!userId || !businessId || !role) return;
        overlayContext.startLoader(exchangeTokenLoader);
        const result = await handleRequest(api.plaid.exchangePublicToken({
          publicToken,
          vendorId: mode.type === PlaidMode.Customer ? mode.vendorId : undefined,
          businessId: mode.type === PlaidMode.Customer ? mode.customerId : businessId,
          relationshipId: mode.type === PlaidMode.Customer ? mode.relationshipId : undefined,
          userId,
          role,
          mode: mode.type,
          fundingSourceToReplace: mode.type === PlaidMode.Customer ? mode.fundingSourceToReplace : undefined
        }));
        if (!result.success) {
          const {
            onError
          } = getProps();
          onError && onError(result.error);
        } else {
          const {
            onSuccess
          } = getProps();
          onSuccess && onSuccess(result.data);
        }
        overlayContext.stopLoader(exchangeTokenLoader);
      }
    };
  }, [linkToken]);
  const plaidLink = usePlaidLink(options);
  const getPlaidLink = useStateInRef(plaidLink);
  const getOptions = useStateInRef(options);
  return {
    async open() {
      const {
        mode
      } = getProps();
      overlayContext.startLoader(linkTokenLoader);
      const newLinkToken = await handleRequest(api.plaid.getLinkToken(mode.type, mode.type === PlaidMode.Customer ? {
        relationshipId: mode.relationshipId
      } : undefined));
      if (!newLinkToken.success) {
        const {
          onError
        } = getProps();
        onError && onError(newLinkToken.error);
        overlayContext.stopLoader(linkTokenLoader);
        return;
      }
      const currentOptions = getOptions();
      currentOptions.token = newLinkToken.data;
      setLinkToken(newLinkToken.data);

      // Wait till plaidLink is ready.
      while (!getPlaidLink().ready) {
        await wait(50);
      }
      overlayContext.stopLoader(linkTokenLoader);
      getPlaidLink().open();
    }
  };
}